const es = {
    views: {
        home: {
            addTask: 'Añadir tarea',
            modalName: 'Nombre',
            modalDescription: 'Descripción',
            modalTitle: 'Añadir tarea',
            modalCancel: 'Cancelar',
            modalSave: 'Guardar',
            successAdd: 'Todo añadido',
            successRemove: 'Todo borrado',
        },
    },
    common: {
        titles: {
            tasks: 'Mis tareas',
            personalData: 'Mis Datos',
            personalReturns: 'Mis devoluciones',
        },
        languages: {
            title: 'Idioma',
        },
        errors: {
            removeTodo: 'Error borrando el todo',
            addTodo: 'Error aádiendoe l todo',
        },
    },
};

export default es;
